import {
  Checkbox,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
import About1 from "assets/images/pricing/About.png";
import Culture1 from "assets/images/pricing/culture1.png";
import Culture2 from "assets/images/pricing/culture2.png";
import Culture3 from "assets/images/pricing/culture3.png";

import MDButton from "components/MDButton";
import { Container } from "@mui/material";
import DemoRequestForm from "./components/DemoRequestForm";
import Header from "./components/header";
import Footer from "./components/footer.js";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Helmet } from "react-helmet-async";

const About = () => {
  const aboutContant = [
    "AI-Powered Restaurant Growth",
    "Local & Guest Intelligence   ",
    "Done for you Marketing ",
  ];
  const cardData = [
    {
      id: 1,
      image: Culture2,
      title: "Innovation",
      description:
        "We use AI to turn complex data into simple, effective growth strategies.",
    },
    {
      id: 2,
      image: Culture3,
      title: "Partnership",
      description:
        "TavloAI works as an extension of your team, focused on real, measurable impact.",
    },
    {
      id: 2,
      image: Culture1,
      title: "Community",
      description:
        "We help businesses build stronger local connections and lasting customer relationships.",
    },
  ];
  return (
    <MDBox
      sx={{
        width: "100%",
        maxWidth: {
          xs: "100%",
          md: "1580px",
          xl: "1920px",
        },
        mx: "auto",
        // px: 2,
      }}
    >
      <Helmet>
        <title>
          {" "}
          About TavloAI | Smarter Hospitality with AI Discover TavloAI,
        </title>
        <meta
          name="description"
          content="the AI platform empowering restaurants, cafes, and bars with intelligent insights, automation, and tools to drive growth, engagement, and success."
        />
        <meta name="keywords" content="Tavlo AI" />
      </Helmet>

      <Header></Header>
      <MDBox
        sx={{
          py: 3,
          mt: { xs: 7, sm: 4, md: 16 },
          mb: { xs: 0, sm: 4 },
          backgroundColor: "#fff",
        }}
      >
        <MDBox sx={{ width: "100%", margin: "auto" }}>
          <Grid container spacing={4} alignItems="start">
            {/* Left Side */}
            <Grid item xs={6} md={7}>
              <MDBox
                sx={{
                  width: { xs: "100%", sm: "82%", md: "82%" },
                  ml: { xs: "28px", sm: "100px", md: "auto" },
                  textAlign: "start",
                }}
              >
                <MDTypography
                  variant="h3"
                  sx={{
                    pt: { xs: 0, sm: 4, md: "10px" },
                    width: "80%",
                    mb: 1,
                    fontWeight: 600,
                    fontSize: { xs: "18px", md: "38px" },
                    lineHeight: { xs: "30px", md: "auto" },

                    fontFamily: "Poppins",
                    color: "#318BEC",
                  }}
                >
                  About TavloAI
                </MDTypography>

                <MDTypography
                  sx={{
                    display: { xs: "none", sm: "block", md: "block" },
                    fontSize: "18px",
                    width: "110%",
                    textAlign: "start",
                    color: "#000",
                    lineHeight: 1.7,
                    fontFamily: "Poppins",
                    fontSize: "19px",
                    mb: 2,
                  }}
                >
                  TavloAI is an AI-powered growth platform built to transform
                  how restaurants, cafes & bars connect, grow, and thrive by
                  bringing together guest understanding, local awareness, and
                  brand intelligence. It helps hospitality businesses stay ahead
                  of trends, strengthen community presence, and make smarter
                  decisions effortlessly.
                </MDTypography>
                <List sx={{ mb: 3 }}>
                  {aboutContant.map((item, index) => (
                    <ListItem
                      key={index}
                      disableGutters
                      alignItems="flex-start"
                    >
                      <MDBox
                        sx={{
                          ml: { xs: "3px", sm: "15px", md: "15px" },
                          fontSize: { xs: "5px", sm: "6px", md: "6px" },
                          mr: { xs: 0.5, sm: 1, md: 1 },
                          lineHeight: 2.2,
                          mt: {
                            xs: "5px",
                            sm: "10px",
                            md: "15px",
                          },
                        }}
                      >
                        <FiberManualRecordIcon sx={{ color: "#000" }} />
                      </MDBox>
                      <ListItemText
                        primary={item}
                        primaryTypographyProps={{
                          sx: {
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            lineHeight: { xs: "18px", sm: 1.5, md: 1.9 },
                            color: "#000",
                            fontFamily: "Poppins",
                            fontSize: { xs: "10px", sm: "19px", md: "19px" },
                          },
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
                {/* <MDButton
                  sx={{
                    display: { xs: "none", sm: "block", md: "block" },
                    color: "#fff",
                    // border:  "2px solid #318BEC",
                    padding: "10px, 10px , 10px , 10px",
                    borderRadius: "40px",
                    fontSize: "19px",
                    //   fontWeight: "700",
                    lineHeight: 1.7,
                    textAlign: "left",
                    fontFamily: "urbanist",
                    textTransform: "none",
                    transition: "background-color 0.3s ease",
                    background: "#F47C00",
                    boxShadow: " 5px 5px 15px 1px #00000040",

                    "&:hover": {
                      backgroundColor: "#f98e24",
                    },
                  }}
                >
                  Explore More
                </MDButton> */}
              </MDBox>
            </Grid>

            {/* Right Side: Image */}
            <Grid
              item
              xs={6}
              md={5}
              sx={{
                mt: { xs: -3, sm: 2, md: 3 },
                display: "flex",
                justifyContent: { xs: "center", md: "flex-end" },
                alignItems: "flex-end",
              }}
            >
              <MDBox
                component="img"
                src={About1}
                alt="AI dashboard"
                sx={{
                  width: { xs: "141px", sm: "360px", md: "95%" },
                  // maxWidth: "469px",
                  height: { xs: "141px", sm: "360px", md: "413px" },
                  borderRadius: "16px",
                  objectFit: "cover",
                }}
              />
            </Grid>
          </Grid>
          <MDTypography
            sx={{
              display: { xs: "block", sm: "none", md: "none" },
              fontSize: { xs: "12px", sm: "18px", md: "18px" },
              width: "85%",
              margin: "auto",
              textAlign: "justify",
              color: "#000",
              lineHeight: { xs: "18px", sm: 1.5, md: 1.7 },
              fontFamily: "Poppins",
              mt: -1,
            }}
          >
            TavloAI is an AI-powered growth platform built to transform how
            restaurants, cafes & bars connect, grow, and thrive by bringing
            together guest understanding, local awareness, and brand
            intelligence. It helps hospitality businesses stay ahead of trends,
            strengthen community presence, and make smarter decisions
            effortlessly.
          </MDTypography>
          <MDBox
            sx={{
              display: { xs: "block", sm: "none", md: "none" },
              width: "85%",
              pt: 1,
              margin: "auto",
            }}
          >
            {/* <MDBox
              sx={{
                width: "114px",
                color: "#fff",
                backgroundColor: "#F47C00",
                padding: "6px 16px",
                borderRadius: "4px",
                fontSize: "10px",
                fontWeight: 600,
                lineHeight: "17px",
                fontFamily: "urbanist",
                textTransform: "none",
                transition: "all 0.3s ease-in-out",
                textAlign: "center",
                fontFamily: "Poppins",
                // "&:hover": {
                //   background: "#318BEC",
                // },
              }}
            >
              Explore More
            </MDBox> */}
          </MDBox>
        </MDBox>
      </MDBox>

      <MDBox sx={{ width: "86%", margin: "auto" }}>
        <MDBox
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <MDTypography
            sx={{
              fontWeight: 600,
              fontSize: { xs: "20px", sm: "28px", md: "40px" },
              // fontSize: ,
              color: "#000",
              fontFamily: "Poppins",
            }}
          >
            Our Mission
          </MDTypography>
        </MDBox>
        <MDBox
          sx={{
            width: "100%",
            margin: "auto",
            display: "flex",
            gap: {
              xs: 2,
              sm: 4,
            },
            justifyContent: "end",
            textAlign: "center",
          }}
        >
          <MDBox
            sx={{
              width: { xs: "100%", sm: "auto", md: "auto" },
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "row",
              },
              gap: 4,
              alignItems: "center",
              justifyContent: "center",

              py: 4,
            }}
          >
            {cardData.map((item) => (
              <MDBox
                key={item.id}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: { xs: "266px", sm: "90%", md: "90%" },
                  height: { xs: "194px", sm: "auto", md: "auto" },
                  maxWidth: "600px",
                  backgroundColor: "#fff",
                  borderRadius: { xs: "10px", sm: "25px", md: "25px" },
                  overflow: "hidden",
                  boxShadow: " 2px 9px 42px 0px #00000014",
                  //   px: 2,
                  py: 8,
                }}
              >
                {/* Red Bar */}
                <MDBox
                  sx={{
                    width: { xs: "3px", sm: "9px", md: "9px" },
                    height: { xs: "44px", sm: "50px", md: "70px" },

                    background: " #318BEC",
                  }}
                />

                {/* Image and Text */}
                <MDBox
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: 1,
                    textAlign: "center",
                  }}
                >
                  <MDBox
                    component="img"
                    src={item.image}
                    alt={item.title}
                    sx={{
                      width: { xs: "48px", sm: "auto", md: "auto" },
                      // maxWidth: "469px",
                      height: { xs: "48px", sm: "130px", md: "130px" },
                      borderRadius: "16px",
                      objectFit: "cover",
                    }}
                  />

                  <MDTypography
                    variant="h5"
                    sx={{
                      fontWeight: 600,
                      my: { xs: 2, sm: 3, md: 3 },
                      color: "#000",
                      fontFamily: "Poppins",
                      fontSize: { xs: "16px", sm: "22px", md: "22px" },
                      lineHeight: { xs: "100%", sm: "auto", md: "auto" },
                    }}
                  >
                    {item.title}
                  </MDTypography>

                  <MDTypography
                    variant="body2"
                    sx={{
                      width: { xs: "80%", sm: "73%", md: "73%" },
                      fontWeight: { xs: "400", sm: "600", md: "600" },
                      margin: "auto",
                      color: "#555555",
                      fontFamily: "Poppins",
                      fontSize: { xs: "12px", sm: "16px", md: "16px" },
                      lineHeight: { xs: "18px", sm: "auto", md: "auto" },
                    }}
                  >
                    {item.description}
                  </MDTypography>
                </MDBox>
              </MDBox>
            ))}
          </MDBox>
        </MDBox>
      </MDBox>

      <Grid container>
        <Grid
          item
          lg={12}
          sx={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, rgba(49, 139, 236, 0.6) 100%)",
            py: { xs: 2, sm: 4, md: 12 },
            width: {
              xs: "100%",
              sm: "90%",
              md: "auto",
            },
            pb: {
              xs: 6,
              sm: 4,
              md: 6,
            },
          }}
        >
          <DemoRequestForm />
        </Grid>
      </Grid>
      <Footer></Footer>
    </MDBox>
  );
};

export default About;
